namespace app.model.exporting {
  type FieldMappings = Record<string, string>;
  export const RelativityFieldMappings: FieldMappings = {
    "Identifier": "Identifier",
    "BegBates": "Begin Bates",
    "EndBates": "End Bates",
    "FamilyBegAttachBates": "Begin Bates Attachment",
    "FamilyEndAttachBates": "End Bates Attachment",
    "FamilyBegAttachIdentifier": "Group Identifier",
    "AttachmentFilenameList": "Attachments",
    "NumberOfAttachments": "Attachment Count",
    "IIOIdentifier": "UUID",
    "Custodian": "Custodian",
    "MimeType": "Media Type",
    "AllCustodians": "All Custodians",
    "AllPaths": "All Paths",
    "OriginalFilename": "File Name",
    "OriginalFilenameExtension": "File Extension",
    "OriginalPath": "Source Path",
    "EmailPath": "Email Folder Path",
    "FileSize": "File Size (Bytes)",
    "Language": "Primary La",
    "MD5": "MD5 Hash",
    "SHA1": "SHA1 Hash",
    "ProcessingException": "Exceptions",
    "Creator": "System Created By",
    "Modifier": "System Last Modified By",
    "DocTitle": "Title",
    "EmailSubject": "Email Subject",
    "Author": "File Author",
    "OfficeCategory": "Categories",
    "HasTrackChanges": "Track Changes",
    "HasHiddenSheet": "MS XL Hidden Sheets",
    "HasHiddenRow": "MS XL Hidden Rows",
    "HasHiddenColumn": "MS XL Hidden Columns",
    "EmailId": "Email Entry ID",
    "EmailFrom": "Email From",
    "EmailTo": "Email To",
    "EmailCc": "Email CC",
    "EmailBcc": "Email BCC",
    "EmailAllRecipients": "Recipients",
    "EmailConversationIndex": "Conversation Index",
    "EmailHasDeliveryReceipt": "Delivery Receipt Requested",
    "EmailInternetMessageId": "Email Message ID",
    "EmailImportance": "Importance",
    "EmailSensitivity": "Sensitivity",
    "SentDateTime": "Email Sent Date Time",
    "ReceivedDateTime": "Email Received Date Time",
    "CreatedDateTime": "File Created Date Time",
    "ModifiedDateTime": "File Modified Date Time",
    "AccessedDateTime": "Last Accessed Date Time",
    "PrintDate": "Last Printed Date Time",
    "AppointmentStartDateTime": "Email Start Date Time",
    "AppointmentEndDateTime": "Email End Date Time",
    "TimezoneProcessed": "Time Zone Field",
    "EProperties": "Document Type",
    "Notes": "MS PP Speaker Notes",
    "EmailMessageClass": "Email Message Class"
  };
}
